{
  "view": {
    "title": "Storage Units",
    "storageUnit": "Storage Unit",
    "reserve": "Reserve",
    "cancel": "Cancel",
    "details": "Details",
    "description": "Here you can view storage units and reserve your own storage by clicking on the desired unit.",
    "noStorageAreas": "No storage units available",
    "noPermissions": "No reservation permissions.",
    "acceptTerms": "I accept the rules of {{address}} and storage unit reservation terms"
  },
  "startOption": {
    "today": "Today"
  },
  "legend": {
    "available": "Available",
    "reservedOrInactive": "Reserved",
    "mine": "My reservation",
    "mineUpcoming": "My upcoming reservation",
    "notInUse": "Not in use",
    "ending": "Ending soon",
    "starting": "Starting soon"
  },
  "success": {
    "title": "Storage reservation successful!",
    "description": "{{area}}, at address {{address}}.",
    "starts": "Reservation starts {{date}}"
  },
  "aria": {
    "availableIndicator": "Color indicator for available unit",
    "reservedIndicator": "Color indicator for reserved unit",
    "mineIndicator": "Color indicator for user's own reservation",
    "mineUpcomingIndicator": "Color indicator for upcoming own reservation"
  },
  "price": {
    "label": "Price",
    "perMonth": "{{amount}} / month",
    "fromPerMonth": "from {{amount}} / month"
  },
  "tooltip": {
    "reservation": {
      "current": { "label": "Reservation" },
      "future": { "label": "Future reservation" },
      "previous": { "label": "Previous reservation" }
    },
    "available": "Available",
    "openEnded": "(until further notice)"
  },
  "reservation": {
    "form": {
      "description": "Reserve storage unit",
      "submit": "Reserve"
    },
    "success": {
      "title": "Storage reservation successful!",
      "description": "Storage unit {{area}} reserved from {{date}}",
      "starts": "Reservation starts"
    }
  },
  "effectiveFrom": "Change takes effect",
  "error": {
    "contractMissing": "Contract information missing - reservation cannot be made.",
    "reservationFailed": "Reservation failed. Please try again later.",
    "overlap": "Selected start date conflicts with existing reservation. Choose another date or end current reservation.",
    "terminationFailed": "Reservation termination failed. Please try again later.",
    "reservationStartBeforeContractStart": "Reservation cannot start before the contract start date."
  },
  "terminate": {
    "form": {
      "description": "Terminate storage unit",
      "submit": "Terminate"
    },
    "endDateLabel": "Change takes effect",
    "futureReservationLabel": "Reservation takes effect",
    "cta": "Cancel reservation",
    "success": "Reservation cancelled",
    "cancelledTitle": "Storage reservation cancelled",
    "cancelledFrom": "Storage unit {{area}} reservation has been cancelled from {{date}}",
    "reservationStartedOn": "Reservation start date: {{date}}"
  },
  "modal": {
    "rulesLink": "Rules",
    "termsLink": "Reservation terms"
  },
  "extraService": {
    "myReservations": "My Storage Reservations",
    "startDate": "Start date",
    "endDate": "End date",
    "openEnded": "Open-ended",
    "active": "Active",
    "ending": "Ending soon",
    "pincode": {
      "code": "Access code: {{pincode}}",
      "loading": "Loading access code...",
      "loadError": "Failed to load access code"
    }
  }
}
